import {StyleSheet} from "aphrodite";
import * as React from "react";
import type {RenderElementProps} from "slate-react";

import {addStyle} from "@khanacademy/wonder-blocks-core";
import {semanticColor, spacing} from "@khanacademy/wonder-blocks-tokens";
import {BodyMonospace} from "@khanacademy/wonder-blocks-typography";

const StyledPre = addStyle("pre");

export default function CodeBlockNode(
    props: RenderElementProps,
): React.ReactElement {
    const {attributes, children} = props;

    return (
        <StyledPre {...attributes} style={styles.pre}>
            <BodyMonospace tag="code" style={styles.code}>
                {children}
            </BodyMonospace>
        </StyledPre>
    );
}

const styles = StyleSheet.create({
    pre: {
        backgroundColor: semanticColor.core.background.neutral.subtle,
        padding: spacing.xSmall_8,
        overflow: "visible",
        marginBlockEnd: spacing.medium_16,
        whiteSpace: "break-spaces",
    },
    code: {
        background: "none",
        fontSize: 16,
    },
});
